// const { Dialog } = require('./modal');

import validate from '../vendor/validate';

// remove error message from dropzone fields
const removeErrorMsg = (elem) => {
    if (elem.classList.contains('error')) {
        elem.classList.remove('error');
        const errorEl = elem.querySelector('.error-message');
        elem.removeChild(errorEl);
    }
};

const isHidden = (el) => {
    var style = window.getComputedStyle(el);
    return style.display === 'none' || style.visibility === 'hidden';
};

const showElement = (elem) => {
    if (elem.getAttribute('aria-hidden') !== 'false') {
        elem.removeAttribute('hidden');
        elem.setAttribute('aria-hidden', 'false');
    }
};

const hiddenElement = (elem) => {
    if (elem.getAttribute('aria-hidden') !== 'true') {
        elem.hidden = true;
        elem.setAttribute('aria-hidden', 'true');
    }
};

const handleDonateAmountChange = (event) => {
    const value = parseFloat(event.target.value).toFixed(2);
    const donateForm = document.querySelector('#donateForm');
    const frequencyChecked = donateForm.querySelector('input[name="donateFrequency"]:checked');
    const frequencyValue = frequencyChecked ? frequencyChecked.value : null;

    const sumbitBtn = donateForm.querySelector('.js-submit-button');
    if (value && value >= 0.3) {
        sumbitBtn.innerHTML = `Give £${value}${frequencyValue === 'monthly' ? ' per month' : ' once'}`;
    } else {
        sumbitBtn.innerHTML = 'Donate';
    }

    if (event.target.hasAttribute('required')) {
        validate.inputHandler(event);
    }
};

const handleDonateFrequencyChange = (event) => {
    const value = event.target.value === 'monthly' ? 'per month' : 'once';
    const donateForm = document.querySelector('#donateForm');
    const amountChecked = donateForm.querySelector('input[name="donateAmount"]:checked');
    const floatAmountChecked = parseFloat(amountChecked.value).toFixed(2);
    const amountValue = amountChecked ? '£' + floatAmountChecked : null;
    const customAmount = parseFloat(donateForm.querySelector('input[name="customAmount"]').value).toFixed(2);
    const customAmountValue = customAmount ? '£' + customAmount : null;

    if ((amountValue && floatAmountChecked >= 0.3) || (customAmountValue && customAmount > 0.3)) {
        const sumbitBtn = donateForm.querySelector('.js-submit-button');
        sumbitBtn.innerHTML = `Give ${amountValue || customAmountValue} ${value}`;
    }
    validate.inputHandler(event);
};

const handleCustomAmountInput = (event) => {
    const floatValue = parseFloat(event.target.value).toFixed(2);
    const value = floatValue ? '£' + floatValue : '';
    const donateForm = document.querySelector('#donateForm');
    const frequencyChecked = donateForm.querySelector('input[name="donateFrequency"]:checked');
    const frequencyValue = frequencyChecked ? frequencyChecked.value : null;

    const sumbitBtn = donateForm.querySelector('.js-submit-button');
    if (value && floatValue && floatValue >= 0.3) {
        sumbitBtn.innerHTML = `Give ${value}${frequencyValue === 'monthly' ? ' per month' : ' once'}`;
    } else {
        sumbitBtn.innerHTML = 'Donate';
    }

    validate.inputHandler(event);
};

const hiddenManualSection = (form) => {
    const manualSection = form.querySelector('.custom-donate');
    const inputEls = manualSection.querySelectorAll('input[name="customAmount"]');
    const amountRadioSection = form.querySelector('#amountRadios');
    const amountRadios = amountRadioSection.querySelectorAll('input[type="radio"][name="donateAmount"]');
    const switcherButton = form.querySelector('.js-custom-amount');

    showElement(amountRadioSection);
    amountRadios.forEach(amountRadio => {
        amountRadio.required = true;
        amountRadio.setAttribute('aria-required', 'true');
        amountRadio.addEventListener('change', handleDonateAmountChange);
    });

    hiddenElement(manualSection);
    inputEls.forEach((inputEl) => {
        inputEl.required = false;
        inputEl.value = null;
        inputEl.setAttribute('aria-required', 'false');
        removeErrorMsg(inputEl.closest('.form-group'));
        inputEl.removeEventListener('blur', validate.inputHandler);
        inputEl.removeEventListener('input', handleCustomAmountInput);
        inputEl.removeEventListener('change', handleCustomAmountInput);
    });

    switcherButton.innerHTML = 'I want to enter my own amount';
};

const showManualSection = (form) => {
    const manualSection = form.querySelector('.custom-donate');
    const inputEls = manualSection.querySelectorAll('input[name="customAmount"]');
    const amountRadioSection = form.querySelector('#amountRadios');
    const amountRadios = amountRadioSection.querySelectorAll('input[type="radio"][name="donateAmount"]');
    const switcherButton = form.querySelector('.js-custom-amount');

    hiddenElement(amountRadioSection);
    amountRadios.forEach(amountRadio => {
        amountRadio.required = false;
        amountRadio.setAttribute('aria-required', 'false');

        if (amountRadio.checked) {
            amountRadio.checked = false;
        }
        removeErrorMsg(amountRadio.closest('.form-group'));
        amountRadio.removeEventListener('change', handleDonateAmountChange);
    });

    showElement(manualSection);
    inputEls.forEach((inputEl) => {
        inputEl.required = true;
        inputEl.setAttribute('aria-required', 'true');
        inputEl.addEventListener('blur', validate.inputHandler);
        inputEl.addEventListener('input', handleCustomAmountInput);
        inputEl.addEventListener('change', handleCustomAmountInput);
    });

    switcherButton.innerHTML = 'I want to choose my amount';
};

const initValidate = (form) => {
    const inputEls = form.querySelectorAll('input[required]:not([type="radio"]):not([type="checkbox"])');
    for (const inputEl of inputEls) {
        inputEl.addEventListener('blur', validate.inputHandler);
        inputEl.addEventListener('input', validate.inputHandler);
        inputEl.addEventListener('change', validate.inputHandler);
    }

    const selectEls = form.querySelectorAll('select[required]');
    for (const selectEl of selectEls) {
        selectEl.addEventListener('change', validate.inputHandler);
    }

    const controlEls = form.querySelectorAll('input[required][type="checkbox"]');
    for (const el of controlEls) {
        el.addEventListener('change', validate.inputHandler);
    }
};

const validateForm = (form) => {
    let formID = form.getAttribute('id');
    let requiredFields = document.querySelectorAll('#' + formID + ' [required]');

    let hasErrors,
        formErrors = false;

    for (const reqField of requiredFields) {
        const error = validate.hasError(reqField);

        if (error) {
            validate.showError(reqField, error);
            if (!hasErrors) {
                hasErrors = reqField;
            }
        }
    }

    if (hasErrors) {
        hasErrors.focus();
        formErrors = true;
    }

    return !formErrors;
};

const initDonateForm = (form) => {
    const cAmountSection = form.querySelector('.custom-donate');
    const cAmountController = form.querySelector('.js-custom-amount');

    if (cAmountController) {
        cAmountController.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();

            const sumbitBtn = form.querySelector('.js-submit-button');
            sumbitBtn.innerHTML = 'Donate';
            isHidden(cAmountSection) ? showManualSection(form) : hiddenManualSection(form);
        });
    }

    // handle radios
    const donateFreqRadios = form.querySelectorAll('[name="donateFrequency"]');
    donateFreqRadios.forEach(radio => {
        radio.addEventListener('change', handleDonateFrequencyChange);
    });

    // handle amount radios
    const donateAmountRadios = form.querySelectorAll('[name="donateAmount"]');
    donateAmountRadios.forEach(radio => {
        radio.addEventListener('change', handleDonateAmountChange);
    });
};

const validatingForms = document.querySelectorAll('.js-validate-form');

for (const formNode of validatingForms) {
    formNode.setAttribute('novalidate', 'true');
    initValidate(formNode);

    formNode.addEventListener('submit', function (event) {
        // event.preventDefault();

        const subBtn = formNode.querySelector('.js-submit-button');
        const subBtnValue = subBtn.value;
        subBtn.disabled = true;
        subBtn.value = 'Processing';

        const isFormValid = validateForm(formNode);

        if (isFormValid) {
            subBtn.disabled = false;
            subBtn.value = subBtnValue;
            return true;
        } else {
            event.preventDefault();
            subBtn.disabled = false;
            subBtn.value = subBtnValue;

            return false;
        }
    });
}

//  For newsletter form specifically
// const newsletterForms = document.querySelectorAll('.js-newsletter-submit');
// newsletterForms.forEach((form) => {
//     form.addEventListener('submit', (e) => {
//         e.preventDefault();

//         const isFormValid = validateForm(form);
//         const subBtn = form.querySelector('.js-submit-button');
//         const subBtnValue = subBtn.innerHTML;
//         subBtn.innerHTML = 'Processing';

//         if (isFormValid) {
//             fetch(e.target.action, {
//                 method: 'POST',
//                 body: new FormData(e.target),
//             })
//                 .then(function (response) {
//                     if (response.ok) {
//                         return response.json();
//                     }
//                     return Promise.reject(response);
//                 })
//                 .then(function (res) {
//                     // console.log(res);
//                     let message = document.getElementById('message-container-newsletter');
//                     if (res.success == true) {
//                         message.innerHTML = '<div class="alert-success">Thank you, your details have been registered with us.</div>';
//                         window.dataLayer.push({
//                             event: 'eventTracking',
//                             category: 'formCompletion',
//                             action: 'newsletter',
//                             label: `${window.location.pathname}`,
//                         });
//                     } else {
//                         message.innerHTML = '<div class="alert-error">Sorry there has been a problem submitting the form: ' + res.message + '</div>';
//                     }

//                     message.scrollIntoView({
//                         behavior: 'smooth',
//                     });

//                     subBtn.innerHTML = subBtnValue;
//                 })
//                 .catch(function (error) {
//                     console.warn(error);
//                 });
//         } else {
//             subBtn.innerHTML = subBtnValue;
//             return false;
//         }
//     });
// });

//  For donate form specifically
const donateForm = document.querySelector('#donateForm');
if (donateForm) {
    donateForm.setAttribute('novalidate', 'true');
    initDonateForm(donateForm);

    donateForm.addEventListener('submit', function (event) {
        // event.preventDefault();

        const subBtn = donateForm.querySelector('.js-submit-button');
        const subBtnInnerHTML = subBtn.innerHTML;
        subBtn.disabled = true;
        subBtn.innerHTML = 'Processing';

        const isFormValid = validateForm(donateForm);

        if (isFormValid) {
            subBtn.disabled = false;
            subBtn.innerHTML = subBtnInnerHTML;
            return true;
        } else {
            event.preventDefault();
            subBtn.disabled = false;
            subBtn.innerHTML = subBtnInnerHTML;

            return false;
        }
    });
}

// window.addEventListener('load', (event) => {
//     if (window.location.href.includes('signup-newsletter')) {
//         const _m = new Dialog('#newsletterModal', this, null, true);
//     }
// });